// extracted by mini-css-extract-plugin
export default {"forgot__links":"Forgot_forgot__links__xg+bn AuthPage_auth__links__ws-cL","forgot":"Forgot_forgot__+s5Ge"};